import { BusinessFeatures } from '../utils/FeatureUtils';
import { BusinessSubscriptionType } from './misc';
import Community from './community';

export type BusinessSubscription = {
  subscriptionId: string;
  productId: string;
  active: boolean;
  willRenew: boolean;
  type: BusinessSubscriptionType;
};

export type BusinessDashboard = {
  dashboardId: number;
  features?: BusinessFeatures;
};

export default interface Business {
  businessId: number;
  role: BusinessRole;
  invite: string;
  picture: string | null;
  name: string;
  description: string;
  type: BusinessType;
  stripeCustomerId?: string | null;
  subscription?: BusinessSubscription;
  trialType?: BusinessSubscriptionType;
  trialEndDate?: string | Date;
  dashboard?: BusinessDashboard;
  community?: Community;
}

export enum BusinessType {
  SPORTCLUB = 'SPORTCLUB',
  STUDENTASSOCIATION = 'STUDENTASSOCIATION',
  OTHER_BUSINESS = 'OTHER_BUSINESS',
}

export enum BusinessRole {
  OWNER = 'OWNER',
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER',
}

export enum BusinessAdminRole {
  MANAGER = 'MANAGER',
  OWNER = 'OWNER',
}